import { FunctionComponent } from "react";
import { styled, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { colorGrayLight } from "../../styles/theme";

export enum CardViewOption {
	SUMMARY = "Summary",
	THREE_MIN_READ = "3 min read",
	FULL_ARTICLE = "Full article",
	BASKET = "Basket",
}

interface Props {
	currentView: CardViewOption;
	onViewChange: (value: CardViewOption) => void;
}

const RoundedToggleGroup = styled(ToggleButtonGroup)(({ theme }) => ({
	display: "inline-flex",
	border: `1px solid ${theme.palette.grey[300]}`,
	borderRadius: 999,
	overflow: "hidden",
	width: "275px",
	padding: "2px",
	height: "34px",

	"& .MuiToggleButton-root": {
		border: 0,
		textTransform: "none",
		flex: 1,
		padding: theme.spacing(1, 2),
		whiteSpace: "nowrap",
		fontSize: "12px",

		"&.Mui-selected": {
			backgroundColor: colorGrayLight,
			color: theme.palette.text.primary,
			borderRadius: 999,
		},
		"&:hover": {
			borderRadius: 999,
		},
	},
}));

const ToggleCardView: FunctionComponent<Props> = ({
	currentView,
	onViewChange,
}) => {
	const handleViewChange = (e, v) => {
		if (currentView === v) return;
		onViewChange(v);
	};
	return (
		<RoundedToggleGroup
			color="primary"
			value={currentView}
			exclusive
			onChange={handleViewChange}
			aria-label="Platform"
		>
			{Object.values(CardViewOption).map((option) => (
				<ToggleButton key={option} value={option}>
					{option}
				</ToggleButton>
			))}
		</RoundedToggleGroup>
	);
};

export default ToggleCardView;
